import { render, staticRenderFns } from "./UserSettingTips.vue?vue&type=template&id=710f070c&scoped=true&"
import script from "./UserSettingTips.vue?vue&type=script&lang=js&"
export * from "./UserSettingTips.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingTips.vue?vue&type=style&index=0&id=710f070c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f070c",
  null
  
)

export default component.exports